<template>
    <div class="Stats">
        <div class="Stats-Container">
            <div class="Stats-Element" v-for="(stat, index) in this.stats" :key="index">
                <div class="Stats-Circle">
                    <img :src="`/img/${stat.src}`" :alt="stat.alt" />
                </div>
                <p class="Stats-Stat">
                    {{ stat.stat }}
                </p>
                <p class="Stats-Text">
                    {{ stat.text }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Stats",
    props: ['stats']
}
</script>

<style scoped>
/* 
* Global 
*/
.Stats-Container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.Stats-Element {
    width: 185px;
    margin: 20px 50px;
}

/* 
* Circle 
*/
.Stats-Circle {
    background: rgba(0, 174, 176, 0.1);
    border-radius: 100%;
    width: 75px;
    height: 75px;
    margin: auto;
    display: flex;
    justify-content: center;
}

.Stats-Circle img {
    width: 25px;
    position: relative;
    margin: auto;
    display: block;
}

/* 
* Text 
*/
.Stats-Stat {
    font-size: 16px;
    font-family: 'GothamBold';
    font-weight: bolder;
    margin: 25px auto;
}

.Stats-Text {
    text-transform: uppercase;
    height: 30px;
}

</style>